import { router, useNavigation } from 'expo-router';

import { Button, IconChevronLeft, Text, tokens } from '@fhs/ui';

interface IAuthHeaderMiddleProps {
  title: string;
}

export function AuthHeaderMiddle(props: IAuthHeaderMiddleProps) {
  return <Text.Heading type="four">{props.title}</Text.Heading>;
}

export function AuthHeaderLeft() {
  const navigation = useNavigation();
  return (
    <Button
      type="ghost"
      onPress={() => {
        const { routes } = navigation.getState();
        if (routes.length > 1) {
          router.dismissTo('/v2/signin');
        } else {
          router.back();
        }
      }}
    >
      <Button.Icon color={tokens.colors.$blackOpacity75} size={24}>
        <IconChevronLeft />
      </Button.Icon>
    </Button>
  );
}
